import type { MegaComponentType } from '@repo/types';
import { NavMegaTable } from './NavMegaTable';
import { NavMegaFixtures } from './NavMegaFixtures';
import { NavMegaResults } from './NavMegaResults';
import { NavMegaScorers } from './NavMegaScorers';

export type MegaEmbedProps = {
  competitionId?: string;
  /** Closes the mega menu panel — only NavMegaScorers uses this today (its player links). */
  onNavigate?: () => void;
};

export const MEGA_EMBEDS: Record<MegaComponentType, (props: MegaEmbedProps) => JSX.Element | null> = {
  leagueTable: NavMegaTable,
  fixtures: NavMegaFixtures,
  results: NavMegaResults,
  topScorers: NavMegaScorers,
};

export { NavMegaTable, NavMegaFixtures, NavMegaResults, NavMegaScorers };
export {
  buildFixtureListParams,
  buildHeaderMegaPrefetches,
  NAV_MEGA_FIXTURES_PARAMS,
  NAV_MEGA_RESULTS_PARAMS,
  TOP_SCORERS_QUERY,
} from './megaPrefetch';
export type { HeaderMegaPrefetch } from './megaPrefetch';
